class HamburgerMenu {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const humBtn = document.querySelector('.js-hum');
    const entryNone = document.querySelector('.hum-none');
    const headerLogo = document.querySelector('.h-logo');
    const humMenu = document.querySelector('.humMenu');
    const body = document.querySelector('body');

    humBtn.addEventListener('click', ()=> {
      humMenu.classList.toggle('is-active');
      humBtn.classList.toggle('is-active');
      body.classList.toggle('no-scroll');
      setTimeout(() => {
        entryNone.classList.toggle('is-hidden');
      },200);
      setTimeout(() => {
        headerLogo.classList.toggle('is-active');
      },400);
    })


    function isMobile() {
      return window.innerWidth <= 768;
    }
    
    $('.js-acc-trigger').on('click', function(e) {
      if (isMobile()) {
        e.preventDefault();
        $(this).toggleClass('is-active');
        $(this).next('.js-acc-content').slideToggle();
      }
    });
  
    $(window).on('resize', function() {
      if (!isMobile()) {
        $('.js-acc-content').removeAttr('style');
        $('.js-acc-trigger').removeClass('is-active');
      }
    });

  }
}
